import axios from "axios";
const baseUrl =
  "https://gateway-admin-plus.sistemasinteegra.com.br/api-admin-ranking";

async function setAdminPlusRankingPoints(
  rankingCode = "",
  guestId = "",
  eventId = ""
) {
  try {
    const _options = {
      url: `https://gateway-admin-plus.sistemainteegra.com.br/api-admin-ranking/events/${eventId}/logins/${guestId}/earnedpointcreate`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        code: rankingCode,
        positive: true,
        log: "Hall",
      },
    };

    await axios(_options);
  } catch (error) {
    // console.log("Error setAdminPlusRankingPoints", error);
    throw error;
  }
}

function getRanking(eventId) {
  var config = {
    method: "get",
    url: `https://gateway-admin-plus.sistemasinteegra.com.br/api-admin-ranking/public/events/${eventId}/ranking?offset=1&limit=10`,
    headers: {
      "Content-Type": "application/json",
    },
    // data: {
    //   eventId: eventId,
    // },
  };

  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function getRankingGuest(eventId, loginId) {
  var config = {
    method: "GET",
    url: `${baseUrl}/events/${eventId}/logins/${loginId}/totalpoints`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export { setAdminPlusRankingPoints, getRanking, getRankingGuest };
